import { useEffect } from 'react'
import { creditsApi, useGetCreditsHistoryQuery } from '@/features/ai/creditsApi'

/**
 * Страница истории движений + заранее подгруженные соседние. Без подгрузки клик
 * по стрелке пагинатора ждал ответа сервера с видом «ничего не происходит»:
 * RTK держит в `data` ПРОШЛУЮ страницу, пока не приехала новая. Соседние
 * страницы запрашиваются в фоне, и переход обычно отвечает из кеша сразу.
 *
 * `switching` — новая страница ещё не приехала (в кеше её нет): вместо старой
 * показываем скелет, а не устаревшие строки под новым номером страницы.
 */
export const useHistoryPage = (page: number, limit: number) => {
  const query = useGetCreditsHistoryQuery({ page, limit })
  const prefetch = creditsApi.usePrefetch('getCreditsHistory')
  const pages = query.data?.pages ?? 0

  useEffect(() => {
    if (page < pages) prefetch({ page: page + 1, limit })
    if (page > 1) prefetch({ page: page - 1, limit })
  }, [page, pages, limit, prefetch])

  const switching = query.isFetching && query.currentData === undefined && query.data !== undefined
  return { ...query, switching }
}
